import { render } from "./TheTramYTe.vue?vue&type=template&id=1dd85091"
import script from "./TheTramYTe.vue?vue&type=script&lang=js"
export * from "./TheTramYTe.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__